import {
  CustomFieldSchema,
  CustomFieldType,
  RelationTypeOptions,
} from '@tribeplatform/gql-client/types'
import { getFieldSetting } from '@tribeplatform/react-components/CustomField'

const canRenderField = (field: CustomFieldSchema) => {
  if (
    field.archived ||
    field.type === CustomFieldType.richText ||
    field.key === 'title'
  ) {
    return false
  }

  return true
}

const canFilterByField = (field: CustomFieldSchema) => {
  if (!canRenderField(field)) {
    return false
  }

  // Don't add filter options for arrays and media
  const { type, typeOptions, items } = field
  if (
    (type === CustomFieldType.array &&
      items?.type === CustomFieldType.relation) ||
    (type === CustomFieldType.relation &&
      typeOptions?.relationType === RelationTypeOptions.Media)
  ) {
    return false
  }

  return true
}

export const tableColumnsFromCustomFields = (
  fields: CustomFieldSchema[] = [],
) => {
  return fields.filter(canRenderField).map(field => {
    return {
      accessor: `mappedFields.${field.key}`,
      Header: field.name,
      orderKey: `fields.${field.key}`,
      type: canFilterByField(field) ? field.type : undefined,
      renderer: field.type,
      validators: field.validators,
      items: field.items,
      settings: field.settings,
      subtype: getFieldSetting(field, 'subtype'),
    }
  })
}
